export enum SERVICE_NAME {
  "AFFILIATE_PORTAL_API" = "affiliate-portal-api",
  "AGENCY_DASHBOARD_API" = "agency-dashboard-api",
  "AI_WRAPPER_API" = "ai-wrapper-api",
  "APPENGINE_API" = "appengine-api",
  "AUTOMATION_AD_PUBLISHING_API" = "automation-ad-publishing-api",
  "AUTOMATION_AM_API" = "automation-am-api",
  "AUTOMATION_AM_CLIENT_PORTAL_API" = "automation-am-client-portal-api",
  "AUTOMATION_CALENDARS_API" = "automation-calendars-api",
  "AUTOMATION_CALENDARS_RESERVE_API" = "automation-calendars-reserve-api",
  "AUTOMATION_CAMPAIGNS_API" = "automation-campaigns-api",
  "AUTOMATION_ELIZA_API" = "automation-eliza-api",
  "AUTOMATION_ELIZA_BOT_API" = "automation-eliza-bot-api",
  "AUTOMATION_ELIZA_SOCKET_API" = "automation-eliza-socket-api",
  "AUTOMATION_REPORTING_API" = "automation-reporting-api",
  "AUTOMATION_REPORTING_ATTRIBUTION_API" = "automation-reporting-attribution-api",
  "AUTOMATION_REPORTING_EMAILS_API" = "automation-reporting-emails-api",
  "AUTOMATION_WORKFLOWS_API" = "automation-workflows-api",
  "AUTOMATION_WORKFLOWS_BASE_API" = "automation-workflows-base-api",
  "AUTOMATION_WORKFLOWS_HOOKS_API" = "automation-workflows-hooks-api",
  "AUTOMATION_WORKFLOWS_MARKETPLACE_API" = "automation-workflows-marketplace-api",
  "AUTOMATION_WORKFLOWS_PLATFORM_API" = "automation-workflows-platform-api",
  "BILLING_API" = "billing-api",
  "BLADE_PLATFORM_API" = "blade-platform-api",
  "BLOGS_API" = "blogs-api",
  "BULK_ACTIONS_API" = "bulk-actions-api",
  "BUSINESSES_API" = "businesses-api",
  "CERTIFICATES_API" = "certificates-api",
  "CHAT_WIDGET_API" = "chat-widget-api",
  "CLIENT_PORTAL_API" = "client-portal-api",
  "COMMUNITIES_API" = "communities-api",
  "COMPANIES_API" = "companies-api",
  "CONTACTS_API" = "contacts-api",
  "CUSTOM_OBJECT_API" = "custom-objects-api",
  "CUSTOM_FIELDS_API" = "custom-fields-api",
  "CONVERSATIONS_AI_API" = "conversations-ai-api",
  "CONVERSATIONS_API" = "conversations-api",
  "COURSES_API" = "courses-api",
  "CRM_CONVERSATIONS_SCORING_API" = "crm-conversations-scoring-api",
  "CRM_CONVERSATIONS_URL_SHORTENER_API" = "crm-conversations-url-shortener-api",
  "CRM_CONVERSATIONS_VIDEOS_API" = "crm-conversations-videos-api",
  "CRM_CUSTOM_MENUS_API" = "crm-custom-menus-api",
  "CRM_TRIGGERS_API" = "crm-triggers-api",
  "DOCUMENTS_API" = "documents-api",
  "ELASTIC_SYNC_API" = "elastic-sync-api",
  "EMAIL_AUTH_API" = "email-auth-api",
  "EMAIL_ISV_API" = "email-isv-api",
  "EMAILS_API" = "emails-api",
  "EVENTS_API" = "events-api",
  "FORMS_API" = "forms-api",
  "FUNNELS_API" = "funnels-api",
  "IAM_API" = "iam-api",
  "IAM_CONFIG_API" = "iam-config-api",
  "IAM_TEST_API" = "iam-test-api",
  "INTEGRATIONS_API" = "integrations-api",
  "INTERNAL_TOOLS_API" = "internal-tools-api",
  "INVOICES_API" = "invoices-api",
  "LC_PHONE_API" = "lc-phone-api",
  "LEADCONNECTOR_API" = "leadconnector-api",
  "LEADGEN_CUSTOM_DATA_API" = "leadgen-custom-data-api",
  "LEADGEN_DOMAIN_CONNECT_API" = "leadgen-domain-connect-api",
  "LEADGEN_ECOMMERCE_API" = "leadgen-ecommerce-api",
  "LEADGEN_EMAILS_BUILDER_API" = "leadgen-emails-builder-api",
  "LEADGEN_FUNNELS_CACHE_HTTP_API" = "leadgen-funnels-cache-http-api",
  "LEADGEN_FUNNELS_INFRA_API" = "leadgen-funnels-infra-api",
  "LEADGEN_FUNNELS_STATS_API" = "leadgen-funnels-stats-api",
  "LEADGEN_LOCALIZATION_API" = "leadgen-localization-api",
  "LEADGEN_SSL_CERTS_API" = "leadgen-ssl-certs-api",
  "LEADGEN_WEBSHOT_API" = "leadgen-webshot-api",
  "LINKS_API" = "links-api",
  "LOCATION_PROSPECT_API" = "location-prospect-api",
  "LOCATIONS_API" = "locations-api",
  "LOGS_API" = "logs-api",
  "MARKETPLACE_API" = "marketplace-api",
  "MEDIAS_API" = "medias-api",
  "MEMBERSHIP_BACKEND_API" = "membership-backend-api",
  "MONGO_INDEXING_API" = "mongo-indexing-api",
  "NOTIFICATIONS_API" = "notifications-api",
  "OAUTH_API" = "oauth-api",
  "ONBOARDING_API" = "onboarding-api",
  "OPPORTUNITIES_API" = "opportunities-api",
  "PAYMENTS_API" = "payments-api",
  "PLATFORM_AI_CONTENT_API" = "platform-ai-content-api",
  "PLATFORM_AI_SUPPORT_BOT_API" = "platform-ai-support-bot-api",
  "PLATFORM_API" = "platform-api",
  "PLATFORM_INFRA_KEYCHAIN_API" = "platform-infra-keychain-api",
  "PLATFORM_SERVICES_ISTIO_TEST_API" = "platform-services-istio-test-api",
  "PRODUCTS_API" = "products-api",
  "PROPOSALS_API" = "proposals-api",
  "PROSPECTING_API" = "prospecting-api",
  "PUBLIC_API" = "public-api",
  "REPUTATION_API" = "reputation-api",
  "REQUEST_LOGGER_API" = "request-logger-api",
  "RESELLING_API" = "reselling-api",
  "REVEX_MOBILE_APP_CUSTOMISER_API" = "revex-mobile-app-customiser-api",
  "REVEX_SAAS_API" = "revex-saas-api",
  "REVEX_SAAS_BILLING_API" = "revex-saas-billing-api",
  "REVEX_SAAS_ISV_API" = "revex-saas-isv-api",
  "REVEX_SAAS_PAYMENT_API" = "revex-saas-payment-api",
  "REVEX_SAAS_WALLET_API" = "revex-saas-wallet-api",
  "REVEX_WORDPRESS_BACKBONE_API" = "revex-wordpress-backbone-api",
  "REVEX_WORDPRESS_BRIDGE_API" = "revex-wordpress-bridge-api",
  "REVEX_WORDPRESS_INFRA_API" = "revex-wordpress-infra-api",
  "SAAS_API" = "saas-api",
  "SNAPSHOTS_API" = "snapshots-api",
  "SOCIAL_MEDIA_POSTING_API" = "social-media-posting-api",
  "SOCKETS_API" = "sockets-api",
  "SOCKETS_LIVE_CHAT_API" = "sockets-live-chat-api",
  "STRIPE_CONSUMER_API" = "stripe-consumer-api",
  "SUPPORT_PORTAL_API" = "support-portal-api",
  "SURVEYS_API" = "surveys-api",
  "TASK_SCHEDULER_API" = "task-scheduler-api",
  "TEMPLATES_API" = "templates-api",
  "TOURGUIDE_API" = "tourguide-api",
  "URLS_API" = "urls-api",
  "USERS_API" = "users-api",
  "WEBSHOT_API" = "webshot-api",
  "WORDPRESS_API" = "wordpress-api",
  "YEXT_API" = "yext-api",
  "DOMAINS_API" = "leadgen-domains-api",
  "SUPPORT_AI_API" = "support-ai-api",
  "LABS_API" = "labs-api",
}
